import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { _initialState } from './_initialState';
import { createActions } from './actions';

export const visualizerStore = (set, get) => ({
  ..._initialState,
  ...createActions(set, get),
});

export const useVisualizerStore = create(
  devtools(
    persist(visualizerStore, {
      name: 'wall-visualizer-storage',
      partialize: (state) => ({
        walls: Object.keys(state.walls).reduce((acc, wallId) => {
          const wall = state.walls[wallId];
          acc[wallId] = {
            ...wall,
            // Convert Set to Array for serialization
            occupiedCells: Array.from(wall.occupiedCells),
          };
          return acc;
        }, {}),
        activeWallId: state.activeWallId,
        selectedProduct: state.selectedProduct,
      }),
      // Rehydrate Sets from Arrays
      onRehydrateStorage: () => (state) => {
        if (state && state.walls) {
          Object.keys(state.walls).forEach((wallId) => {
            if (Array.isArray(state.walls[wallId].occupiedCells)) {
              // eslint-disable-next-line no-param-reassign
              state.walls[wallId].occupiedCells = new Set(state.walls[wallId].occupiedCells);
            }
          });
        }
      },
    }),
    { enabled: true, store: 'VISUALIZER', name: '[DESIGNER] VISUALIZER' }
  )
);
